"use client";
import { isValid } from "@/lib/utils";
import { useToast } from "@/components/ui/use-toast";
import React, { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { useContactUsMutation } from "@/redux/apiSlices/formApi";
import { validationRules } from "@/lib/validationRules";
import { Controller, useForm } from "react-hook-form";
import QuestionIcon from "@/icons/QuestionMarkIcon";
import CustomInput from "@/components/ui/customInput";

const ContactPage = ({modalNumber}) => {
  const { toast } = useToast();
  const formRef = useRef(null); // ✅ Create a ref for the form
  const {
    requiredAlphabetOnly,
  } = validationRules;

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: {} });

  const [contactUs, { data, isSuccess, isLoading: isUserLoading, isError, error: errMsg }] = useContactUsMutation();
  useEffect(() => {
    if (isSuccess) {
      if (data?.success) {
        toast({ title: "The email has been sent successfully." })
      }
    }
    if (isError) {
      toast({
        title: errMsg?.data?.msg,
      });
    }
  }, [isSuccess, isError]);

  const onSubmit = async (data) => {
    if (!formRef.current) return;

    try {
      const subject = `Online Product Inquiry - Model ${modalNumber || "N/A"}`;
      const formType=`Online Product Inquiry`
      const description  = `You have received a new product inquiry from ${data.first_name} ${data.last_name} regarding Model ${modalNumber}. Please reach out to the customer for further assistance regarding this item.`
      const formData = { ...data, subject, description, formType };
    
       await contactUs(formData);
      // ✅ Check if `reset` is available before calling
      reset()
    } catch (error) {
      // toast({
      //   title: "Failed to send email. Please try again later.",
      // });
    }
  };

  return (
    <div className=" container-fuild max-w-full border border-[#EAEAEA] px-7 py-5 rounded-10">
        <section >
          <div className=" w-full flex  py-6 bg-white rounded-20">           
            <div className=" flex-1 w-full ">
              <div className="flex items-center space-x-2 item-center mb-[5px] w-fit m-auto">
              <QuestionIcon />
               <h2 className="text-[26px] font-semibold leading-[39px] ">Contact Us to Order</h2>
              </div>
              <p className="text-[11px] font-medium text-center mb-[19px]">
              Under guidelines from the manufacturer, this item isn&apos;t available for purchase directly off of our website. However, we can sell this to you in our store
              </p>

              <div className="w-full   ">
                <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid grid-cols-1 gap-2">
                    <div className="grid grid-cols-2 gap-x-6 sm:grid-cols-1">
                    <input type="hidden" name="subject" value={`Online Product Inquiry - Model ${modalNumber || "N/A"}`} /> 

                      <Controller
                        name="first_name"
                        control={control}
                        rules={requiredAlphabetOnly("First Name")}
                        render={({ field }) => (
                          <CustomInput
                            labelClassName=" bg-white"
                            label="First Name*"
                            maxLength={25}
                            isInvalid={isValid("first_name", errors)}
                            errorMessage={errors.first_name?.message}
                            {...field}
                          />
                        )}
                      />

                      <Controller
                        name="last_name"
                        control={control}
                        rules={requiredAlphabetOnly("Last Name")}
                        render={({ field }) => (
                          <CustomInput
                            labelClassName=" bg-white"
                            label="Last Name*"
                            maxLength={25}
                            isInvalid={isValid("last_name", errors)}
                            errorMessage={errors.last_name?.message}
                            {...field}
                          />
                        )}
                      />

                     <Controller
                        name="zipcode"
                        control={control}
                        rules={{
                          required: "Zip code is required",
                          pattern: {
                            value: /^[0-9]{5}$/,
                            message: "Invalid zip code format",
                          },
                        }}
                        render={({ field }) => (
                          <CustomInput
                            labelClassName="bg-white"
                            label="Zipcode*"
                            maxLength={5}
                            isInvalid={isValid("zipcode", errors)}
                            errorMessage="Please enter valid zip code"
                            {...field}
                          />
                        )}
                      />

                      <Controller
                        name="mobile"
                        control={control}
                        rules={{
                          required: "Phone number is required",
                          validate: (value) => value.trim() !== "" || "Only spaces are not allowed",
                          pattern: {
                            value: /^[0-9]+$/, // Only numbers
                            message: "Phone number must contain only digits",
                          },
                          minLength: {
                            value: 10, // Adjust based on your needs
                            message: "Please enter a valid 10-digit",
                          },
                          maxLength: {
                            value: 10, // Adjust based on your needs
                            message: "Please enter a valid 10-digit",
                          },
                        }}
                        render={({ field }) => (
                          <CustomInput
                            labelClassName="bg-white"
                            label="Phone Number*"
                            isInvalid={isValid("mobile", errors)}
                            errorMessage={errors.mobile?.message}
                            {...field}
                          />
                        )}
                      />
                    </div>

                     <Controller
                        name="email"
                        control={control}
                        rules={{
                          required: "Please enter email ",
                          pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Please enter valid email",
                          },
                        }}
                        render={({ field }) => (
                          <CustomInput
                            label="Email"
                            maxLength={1000}
                            isInvalid={isValid("email", errors)}
                            errorMessage="Please enter valid email"
                            {...field}
                          />
                        )}
                      />
                  </div>

                  <div className="mt-[15px] w-full flex justify-between  md:block">
                    <Button
                      className="w-full h-[50px] md:w-full bg-[#CE000E] font-medium  text-[14px] text-white px-6 py-3 rounded-[10px] shadow-md  focus:outline-none focus:ring-2  focus:ring-opacity-50"
                      type="submit"
                    >
                     Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
    </div>
  );
};

export default ContactPage;